export default __webpack_public_path__ + "static/action-against-hunger-v2-02f0d5acc8531f15508bd7bb2e9631f5.jpg";